import React from 'react';
import PropTypes from 'prop-types';
import log from 'core/libs/logger';

const Icon = ({color, type}) => {
  switch (type) {
    case 'videotutorial':
      return (
        <path
          fill={color}
          d="M 11.132525,9.2185183 V 16.981481 L 16.954747,13.10097 Z"
        />
      );
    case 'codechallenge':
      return (
        <path
          fill={color}
          d="M10 17.4c.2 0 .4 0 .6-.2.3-.2.3-.7 0-1l-3.5-3 3.6-3.3c.3-.3.3-.8 0-1-.4-.3-.8-.3-1 0l-4.7 4 4.5 4.2c0 .2.3.2.5.2zM16.2 17.4c-.2 0-.4 0-.6-.2-.3-.2-.3-.7 0-1l3.5-3-3.4-3.3c-.3-.3-.3-.8 0-1 .4-.3.8-.3 1 0l4.7 4-4.6 4.2c0 .2-.3.2-.5.2z"
        />
      );
    case 'quiz':
      return (
        <path
          fill={color}
          d="M10.05 8.55c.48-.36 1-.7 1.56-.9 1.27-.35 2.73-.27 3.8.54.62.47.78 1.32.73 2.07-.06.82-.5 1.58-1.17 2.06-.42.34-1.06.53-1.2 1.12-.17.38 0 1.08-.3 1.3h-1.4c0-.66-.3-1.4.1-2 .5-.65 1.34-.92 1.76-1.63.38-.55.3-1.5-.37-1.76-.74-.3-1.56 0-2.2.4-.6.33-.82-.47-1.08-.85l-.22-.35zm1.5 9c-.03-.9 1.1-1.65 1.9-1.14.63.34.94 1.22.5 1.82-.27.53-.9.6-1.43.5-.54-.07-1.04-.6-.97-1.17z"
        />
      );
    case 'note':
      return (
        <g fill={color} style={{transform: 'translate(8px,8px)'}}>
          <path d="M10.4 8.5H8.9c-.2 0-.4.2-.4.4v1.5a.1.1 0 0 0 .2.1l1.8-1.8a.1.1 0 0 0-.1-.2z" />
          <path d="M10.3 0H.7C.4 0 0 .3 0 .6v9.7c0 .3.3.6.6.6h6.6c.2 0 .3-.1.3-.3V9c0-.7.6-1.3 1.3-1.3h1.7c.1 0 .3 0 .3-.2V.6c0-.3-.3-.6-.6-.6zm-4 7.1H2a.4.4 0 0 1 0-.8h4.1a.4.4 0 0 1 0 .8zm2.7-2H2a.4.4 0 0 1 0-1h7a.4.4 0 0 1 0 1zm0-2.2H2A.4.4 0 0 1 2 2h7A.4.4 0 0 1 9 3z" />
        </g>
      );
    case 'project':
      return (
        <g fill={color} style={{transform: 'translate(5.5px,5.5px)'}}>
          <path d="M 2.5 2 C 1.675781 2 1 2.675781 1 3.5 L 1 12.5 C 1 13.324219 1.675781 14 2.5 14 L 13.5 14 C 14.324219 14 15 13.324219 15 12.5 L 15 5.5 C 15 4.675781 14.324219 4 13.5 4 L 6.796875 4 L 6.144531 2.789063 C 5.882813 2.300781 5.375 2 4.824219 2 Z M 2.5 3 L 4.824219 3 C 5.007813 3 5.175781 3.101563 5.265625 3.261719 L 5.664063 4 L 2 4 L 2 3.5 C 2 3.21875 2.21875 3 2.5 3 Z M 2 5 L 13.5 5 C 13.78125 5 14 5.21875 14 5.5 L 14 12.5 C 14 12.78125 13.78125 13 13.5 13 L 2.5 13 C 2.21875 13 2 12.78125 2 12.5 Z " />
        </g>
      );
    case 'locked':
      return(
        <svg xmlns="http://www.w3.org/2000/svg" x="1.5px" y="1px"
          fill={color}
        >
          <path d="M 12 1 C 8.6761905 1 6 3.6761905 6 7 L 6 8 C 4.9069372 8 4 8.9069372 4 10 L 4 20 C 4 21.093063 4.9069372 22 6 22 L 18 22 C 19.093063 22 20 21.093063 20 20 L 20 10 C 20 8.9069372 19.093063 8 18 8 L 18 7 C 18 3.6761905 15.32381 1 12 1 z M 12 3 C 14.27619 3 16 4.7238095 16 7 L 16 8 L 8 8 L 8 7 C 8 4.7238095 9.7238095 3 12 3 z M 6 10 L 18 10 L 18 20 L 6 20 L 6 10 z M 12 13 C 10.9 13 10 13.9 10 15 C 10 16.1 10.9 17 12 17 C 13.1 17 14 16.1 14 15 C 14 13.9 13.1 13 12 13 z"></path>
        </svg>
      )
    default:
      log('Corrupted step !!', {
        type,
        currentUrl: typeof window !== 'undefined' && window.location.href,
      });
      return <span />;
  }
};
Icon.propTypes = {
  color: PropTypes.string,
  type: PropTypes.string,
};

const StepIcon = (props) => {
  const {color = '#000', height = '23px', width = '23px', type} = props;
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 27"
      className="ml2 self-center"
    >
      <circle fill={color} cx="13.5" cy="13.5" r="13.5" />
      <Icon type={type} color="white" />
    </svg>
  );
};

StepIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
};

export default StepIcon;
